import { render, staticRenderFns } from "./specificInfo-rb.vue?vue&type=template&id=5494dd40&scoped=true"
import script from "./specificInfo-rb.vue?vue&type=script&lang=js"
export * from "./specificInfo-rb.vue?vue&type=script&lang=js"
import style0 from "./specificInfo-rb.vue?vue&type=style&index=0&id=5494dd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5494dd40",
  null
  
)

export default component.exports